import { render, staticRenderFns } from "./bottomRight.vue?vue&type=template&id=ed9dabfe&scoped=true"
import script from "./bottomRight.vue?vue&type=script&lang=js"
export * from "./bottomRight.vue?vue&type=script&lang=js"
import style0 from "./bottomRight.vue?vue&type=style&index=0&id=ed9dabfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9dabfe",
  null
  
)

export default component.exports